import React, { Component } from 'react';
import { Button, Table, Checkbox, FormControl, Row, Col, Glyphicon } from 'react-bootstrap'
import Api from '../../../../Global/Modules/Api'
import WerkervaringToevoegen from '../../../Modules/Leden/Lid/Werkervaring/WerkervaringToevoegen'

class DoorlopendeWerkervaring extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.getKennis = this.getKennis.bind(this)
        this.handleChangePageSize = this.handleChangePageSize.bind(this)
        this.handleClickClass = this.handleClickClass.bind(this)
        this.handleWorkingExperienceAdded = this.handleWorkingExperienceAdded.bind(this)
        this.handleClickVerk = this.handleClickVerk.bind(this)
        this.state = {
            kennis: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: '', // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleChangePageSize(e) {
        this.setState({ pagination: { ...this.state.pagination, pageSize: e.target.value } })
        this.getKennis("api/members/" + this.props.id + "/permanentworkingexperience?PageSize=" + e.target.value)
    }
    handleClickClass() {
        if (this.state.tableclass == '') {
            this.setState({ tableclass: 'show-table-full-width' })
        } else {
            this.setState({ tableclass: '' })
        }
    }
    handleDelete = (id) => event => {
        event.preventDefault()
        if (window.confirm('Are you sure you wish to delete this item?')) {
            const FETCH_URL_DELETE = `api/members/${id}/education`
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete ${id}`)
                Api.print(response)
                this.getKennis(this.state.currentFetchUrl) // Update the educations list
            })
        }

        else Api.print('Think it better.')

    }
    handleWorkingExperienceAdded(event) {
        this.child.getWorkingExperiences()
    }
    componentWillMount() {
        const FETCH_URL = "api/members/" + this.props.id + "/permanentworkingexperience"
        this.setState({ currentFetchUrl: FETCH_URL })
        this.getKennis(FETCH_URL)
    }
    handlePaginationClick(e) {
        const FETCH_URL3 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL3 })
        this.getKennis(FETCH_URL3)
    }
    handleClickVerk(e) {
        var url = "api/members/" + e + "/getWerk";
        Api.GetApiDownload(url)
    }
    getKennis(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {

            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            if (objectData !== undefined) {
                this.setState({ kennis: objectData }); // Companies object
            }
        })
    }
    render() {
        let kennis = this.state.kennis
        let points = 0;
        return (
            <div>
                <h5><strong>Doorlopende werkervaring</strong></h5>
                <WerkervaringToevoegen handle={this.handleWorkingExperienceAdded} id={this.props.id} />
                <Button onClick={this.handleClickClass}>Toon volledige tabel</Button>
                <Row>
                    <Col md={1} sm={1}>
                        <FormControl name='pageSize' componentClass="select" placeholder="select" onChange={this.handleChangePageSize} value={this.state.pagination.pageSize}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="0">All</option>
                        </FormControl>
                    </Col>
                </Row>
                <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                <div className={"table-responsive " + this.state.tableclass}>
                    <Table striped bordered hover className="text-center">
                        <thead>
                            <tr>
                                <th>stat</th>
                                <th>niveau</th>
                                <th>werkgever</th>
                                <th>opdr.gever</th>
                                <th>soort project</th>
                                <th>locatie</th>
                                <th>jaar</th>
                                <th>ingevoerde ee's</th>
                                <th>ee's akkoord</th>
                                <th>ref</th>
                                <th>ref bev dat</th>
                                <th>akk dat</th>
                                <th>upl</th>
                                <th>OK</th>
                                <th>verwijder</th>
                            </tr>
                        </thead>
                        <tbody>
                            {kennis !== undefined ? kennis.map((comp) => {
                                points += parseFloat(comp.points)
                                //let editUrl = `/admin/kennis/bijeenkomst/bewerken/${comp.id}`
                                return (<tr key={comp.id}>
                                    <td>{comp.memberType}</td>
                                    {/*
                                    0 = ASP
                                    1 = RC
                                    2 = RO
                                    3 = RTa
                                    4 = RTb
                                    */}
                                    <td>{comp.level}</td>
                                    <td>{comp.company}</td>
                                    <td>{comp.customer}</td>
                                    <td>{comp.project}</td>
                                    <td>{comp.city}</td>
                                    <td>{comp.yearFrom}<br />{comp.yearTo}</td>
                                    <td>{comp.points}</td>{/*TODO: This is a calculation we need to check*/}
                                    <td>{comp.pointsConfirmed}</td>{/*TODO: This is a calculation we need to check*/}
                                    <td>{comp.abbreviation}</td>
                                    <td>{Api.formatDate(comp.referenceRequest)}</td>
                                    <td>{Api.formatDate(comp.dateConfirmation)}</td>
                                    <td>{comp.file != "" && comp.file != null ? <a onClick={() => this.handleClickVerk(comp.id)} target="_blank" title={"Bekijk werkewaring"}>bekijk<br /></a> : ""}</td>
                                    <td><Checkbox checked /></td>
                                    <td><Button bsSize="xsmall" className="delete" onClick={this.handleDelete(comp.id)}>
                                        <Glyphicon glyph="remove" />
                                    </Button></td>
                                </tr >)
                            }) : null}
                        </tbody>
                    </Table>
                </div>
                <div className="paginationStyling">
                    <div style={{ float: 'left' }}>
                        {this.state.pagination.prevButton}
                    </div>
                    <div style={{ float: 'center' }}>
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div style={{ float: 'right' }}>
                        {this.state.pagination.nextButton}
                    </div>
                </div>
            </div>
        )
    }
}
export default DoorlopendeWerkervaring;




// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/DoorlopendeWerkervaring.js